import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { FilerComponent } from './components/filer/filer.component';
import { AgeRangesComponent } from './components/age-ranges/age-ranges.component';
import { AgeRangeFormComponent } from './components/age-ranges/age-range-form/age-range-form.component';
import { AgeRangeDetailsComponent } from './components/age-ranges/age-range-details/age-range-details.component';
import { BannersComponent } from './components/banners/banners.component';
import { BannerFormComponent } from './components/banners/banner-form/banner-form.component';
import { BannerDetailsComponent } from './components/banners/banner-details/banner-details.component';
import { BannerPositionsComponent } from './components/banner-positions/banner-positions.component';
import { BannerPositionFormComponent } from './components/banner-positions/banner-position-form/banner-position-form.component';
import { BannerPositionDetailsComponent } from './components/banner-positions/banner-position-details/banner-position-details.component';
import { BannerTypesComponent } from './components/banner-types/banner-types.component';
import { BannerTypeFormComponent } from './components/banner-types/banner-type-form/banner-type-form.component';
import { BannerTypeDetailsComponent } from './components/banner-types/banner-type-details/banner-type-details.component';
import { CitiesComponent } from './components/cities/cities.component';
import { CityFormComponent } from './components/cities/city-form/city-form.component';
import { CityDetailsComponent } from './components/cities/city-details/city-details.component';
import { ClassDurationsComponent } from './components/class-durations/class-durations.component';
import { ClassDurationFormComponent } from './components/class-durations/class-duration-form/class-duration-form.component';
import { ClassDurationDetailsComponent } from './components/class-durations/class-duration-details/class-duration-details.component';
import { ClicksComponent } from './components/clicks/clicks.component';
import { ClickFormComponent } from './components/clicks/click-form/click-form.component';
import { ClickDetailsComponent } from './components/clicks/click-details/click-details.component';
import { CoachesComponent } from './components/coaches/coaches.component';
import { CoachFormComponent } from './components/coaches/coach-form/coach-form.component';
import { CoachDetailsComponent } from './components/coaches/coach-details/coach-details.component';
import { CommentsComponent } from './components/comments/comments.component';
import { CommentFormComponent } from './components/comments/comment-form/comment-form.component';
import { CommentDetailsComponent } from './components/comments/comment-details/comment-details.component';
import { CompaniesComponent } from './components/companies/companies.component';
import { CompanyFormComponent } from './components/companies/company-form/company-form.component';
import { CompanyDetailsComponent } from './components/companies/company-details/company-details.component';
import { CountriesComponent } from './components/countries/countries.component';
import { CountryFormComponent } from './components/countries/country-form/country-form.component';
import { CountryDetailsComponent } from './components/countries/country-details/country-details.component';
import { FavoritesComponent } from './components/favorites/favorites.component';
import { FavoriteFormComponent } from './components/favorites/favorite-form/favorite-form.component';
import { FavoriteDetailsComponent } from './components/favorites/favorite-details/favorite-details.component';
import { FitnessClassesComponent } from './components/fitness-classes/fitness-classes.component';
import { FitnessClassFormComponent } from './components/fitness-classes/fitness-class-form/fitness-class-form.component';
import { FitnessClassDetailsComponent } from './components/fitness-classes/fitness-class-details/fitness-class-details.component';
import { FitnessGoalsComponent } from './components/fitness-goals/fitness-goals.component';
import { FitnessGoalFormComponent } from './components/fitness-goals/fitness-goal-form/fitness-goal-form.component';
import { FitnessGoalDetailsComponent } from './components/fitness-goals/fitness-goal-details/fitness-goal-details.component';
import { FitnessReservationsComponent } from './components/fitness-reservations/fitness-reservations.component';
import { FitnessReservationFormComponent } from './components/fitness-reservations/fitness-reservation-form/fitness-reservation-form.component';
import { FitnessReservationDetailsComponent } from './components/fitness-reservations/fitness-reservation-details/fitness-reservation-details.component';
import { FitnessSessionsComponent } from './components/fitness-sessions/fitness-sessions.component';
import { FitnessSessionFormComponent } from './components/fitness-sessions/fitness-session-form/fitness-session-form.component';
import { FitnessSessionDetailsComponent } from './components/fitness-sessions/fitness-session-details/fitness-session-details.component';
import { ImpressionsComponent } from './components/impressions/impressions.component';
import { ImpressionFormComponent } from './components/impressions/impression-form/impression-form.component';
import { ImpressionDetailsComponent } from './components/impressions/impression-details/impression-details.component';
import { IntensitiesComponent } from './components/intensities/intensities.component';
import { IntensityFormComponent } from './components/intensities/intensity-form/intensity-form.component';
import { IntensityDetailsComponent } from './components/intensities/intensity-details/intensity-details.component';
import { LanguagesComponent } from './components/languages/languages.component';
import { LanguageFormComponent } from './components/languages/language-form/language-form.component';
import { LanguageDetailsComponent } from './components/languages/language-details/language-details.component';
import { LikesComponent } from './components/likes/likes.component';
import { LikeFormComponent } from './components/likes/like-form/like-form.component';
import { LikeDetailsComponent } from './components/likes/like-details/like-details.component';
import { LiveChannelsComponent } from './components/live-channels/live-channels.component';
import { LiveChannelFormComponent } from './components/live-channels/live-channel-form/live-channel-form.component';
import { LiveChannelDetailsComponent } from './components/live-channels/live-channel-details/live-channel-details.component';
import { LogsComponent } from './components/logs/logs.component';
import { LogFormComponent } from './components/logs/log-form/log-form.component';
import { LogDetailsComponent } from './components/logs/log-details/log-details.component';
import { MembersComponent } from './components/members/members.component';
import { MemberFormComponent } from './components/members/member-form/member-form.component';
import { MemberDetailsComponent } from './components/members/member-details/member-details.component';
import { SportsComponent } from './components/sports/sports.component';
import { SportFormComponent } from './components/sports/sport-form/sport-form.component';
import { SportDetailsComponent } from './components/sports/sport-details/sport-details.component';
import { PacksComponent } from './components/packs/packs.component';
import { PackFormComponent } from './components/packs/pack-form/pack-form.component';
import { PackDetailsComponent } from './components/packs/pack-details/pack-details.component';
import { PackageTypesComponent } from './components/package-types/package-types.component';
import { PackageTypeFormComponent } from './components/package-types/package-type-form/package-type-form.component';
import { PackageTypeDetailsComponent } from './components/package-types/package-type-details/package-type-details.component';
import { PostsComponent } from './components/posts/posts.component';
import { PostFormComponent } from './components/posts/post-form/post-form.component';
import { PostDetailsComponent } from './components/posts/post-details/post-details.component';
import { PostTypesComponent } from './components/post-types/post-types.component';
import { PostTypeFormComponent } from './components/post-types/post-type-form/post-type-form.component';
import { PostTypeDetailsComponent } from './components/post-types/post-type-details/post-type-details.component';
import { PricesComponent } from './components/prices/prices.component';
import { PriceFormComponent } from './components/prices/price-form/price-form.component';
import { PriceDetailsComponent } from './components/prices/price-details/price-details.component';
import { RatingsComponent } from './components/ratings/ratings.component';
import { RatingFormComponent } from './components/ratings/rating-form/rating-form.component';
import { RatingDetailsComponent } from './components/ratings/rating-details/rating-details.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { ReviewFormComponent } from './components/reviews/review-form/review-form.component';
import { ReviewDetailsComponent } from './components/reviews/review-details/review-details.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SettingFormComponent } from './components/settings/setting-form/setting-form.component';
import { SettingDetailsComponent } from './components/settings/setting-details/setting-details.component';
import { SharingsComponent } from './components/sharings/sharings.component';
import { SharingFormComponent } from './components/sharings/sharing-form/sharing-form.component';
import { SharingDetailsComponent } from './components/sharings/sharing-details/sharing-details.component';
import { ShowsComponent } from './components/shows/shows.component';
import { ShowFormComponent } from './components/shows/show-form/show-form.component';
import { ShowDetailsComponent } from './components/shows/show-details/show-details.component';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { SubscriptionFormComponent } from './components/subscriptions/subscription-form/subscription-form.component';
import { SubscriptionDetailsComponent } from './components/subscriptions/subscription-details/subscription-details.component';
import { UsersComponent } from './components/users/users.component';
import { UserFormComponent } from './components/users/user-form/user-form.component';
import { UserDetailsComponent } from './components/users/user-details/user-details.component';
import { VideosComponent } from './components/videos/videos.component';
import { VideoFormComponent } from './components/videos/video-form/video-form.component';
import { VideoDetailsComponent } from './components/videos/video-details/video-details.component';
import { VideoConverterComponent } from './components/videos/video-converter/video-converter.component';
import { VideoCategoriesComponent } from './components/video-categories/video-categories.component';
import { VideoCategoryFormComponent } from './components/video-categories/video-category-form/video-category-form.component';
import { VideoCategoryDetailsComponent } from './components/video-categories/video-category-details/video-category-details.component';
import { VideoTypesComponent } from './components/video-types/video-types.component';
import { VideoTypeFormComponent } from './components/video-types/video-type-form/video-type-form.component';
import { VideoTypeDetailsComponent } from './components/video-types/video-type-details/video-type-details.component';
import { VisitsComponent } from './components/visits/visits.component';
import { VisitFormComponent } from './components/visits/visit-form/visit-form.component';
import { VisitDetailsComponent } from './components/visits/visit-details/visit-details.component';
import { ChallengesComponent } from './components/challenges/challenges.component';
import { ChallengeFormComponent } from './components/challenges/challenge-form/challenge-form.component';
import { ChallengeDetailsComponent } from './components/challenges/challenge-details/challenge-details.component';
// Import Containers
import { DefaultLayoutComponent } from '../containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Dashboard'
        },
      },
      {
        path: 'profile',
        component: ProfileComponent,
        data: {
          title: 'My Profile'
        },
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        data: {
          title: 'Change My Password'
        },
      },
      {
        path: 'filer',
        component: FilerComponent,
        data: {
          title: 'File Manger'
        },
      },
      {
        path: 'filer/:path',
        component: FilerComponent,
        data: {
          title: 'File Manger'
        },
      },
      {
        path: 'age-ranges',
        component: AgeRangesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Age Ranges'
        },
      },
      {
        path: 'age-ranges/add',
        component: AgeRangeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Age Range'
        },
      },
      {
        path: 'age-ranges/edit/:id',
        component: AgeRangeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Age Range'
        },
      },
      {
        path: 'age-ranges/details/:id',
        component: AgeRangeDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Age Range Details'
        },
      },
      {
        path: 'banners',
        component: BannersComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Banners'
        },
      },
      {
        path: 'banners/add',
        component: BannerFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Banner'
        },
      },
      {
        path: 'banners/edit/:id',
        component: BannerFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Banner'
        },
      },
      {
        path: 'banners/details/:id',
        component: BannerDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Banner Details'
        },
      },
      {
        path: 'banner-positions',
        component: BannerPositionsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Banner Positions'
        },
      },
      {
        path: 'banner-positions/add',
        component: BannerPositionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Banner Position'
        },
      },
      {
        path: 'banner-positions/edit/:id',
        component: BannerPositionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Banner Position'
        },
      },
      {
        path: 'banner-positions/details/:id',
        component: BannerPositionDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Banner Position Details'
        },
      },
      {
        path: 'banner-types',
        component: BannerTypesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Banner Types'
        },
      },
      {
        path: 'banner-types/add',
        component: BannerTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Banner Type'
        },
      },
      {
        path: 'banner-types/edit/:id',
        component: BannerTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Banner Type'
        },
      },
      {
        path: 'banner-types/details/:id',
        component: BannerTypeDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Banner Type Details'
        },
      },
      {
        path: 'cities',
        component: CitiesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Cities'
        },
      },
      {
        path: 'cities/add',
        component: CityFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New City'
        },
      },
      {
        path: 'cities/edit/:id',
        component: CityFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit City'
        },
      },
      {
        path: 'cities/details/:id',
        component: CityDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'City Details'
        },
      },
      {
        path: 'class-durations',
        component: ClassDurationsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Class Durations'
        },
      },
      {
        path: 'class-durations/add',
        component: ClassDurationFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Class Duration'
        },
      },
      {
        path: 'class-durations/edit/:id',
        component: ClassDurationFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Class Duration'
        },
      },
      {
        path: 'class-durations/details/:id',
        component: ClassDurationDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Class Duration Details'
        },
      },
      {
        path: 'clicks',
        component: ClicksComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Clicks'
        },
      },
      {
        path: 'clicks/add',
        component: ClickFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Click'
        },
      },
      {
        path: 'clicks/edit/:id',
        component: ClickFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Click'
        },
      },
      {
        path: 'clicks/details/:id',
        component: ClickDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Click Details'
        },
      },
      {
        path: 'coaches',
        component: CoachesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Coaches'
        },
      },
      {
        path: 'coaches/add',
        component: CoachFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Coach'
        },
      },
      {
        path: 'coaches/edit/:id',
        component: CoachFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Coach'
        },
      },
      {
        path: 'coaches/details/:id',
        component: CoachDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Coach Details'
        },
      },
      {
        path: 'comments',
        component: CommentsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Comments'
        },
      },
      {
        path: 'comments/add',
        component: CommentFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Comment'
        },
      },
      {
        path: 'comments/edit/:id',
        component: CommentFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Comment'
        },
      },
      {
        path: 'comments/details/:id',
        component: CommentDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Comment Details'
        },
      },
      {
        path: 'companies',
        component: CompaniesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Companies'
        },
      },
      {
        path: 'companies/add',
        component: CompanyFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Company'
        },
      },
      {
        path: 'companies/edit/:id',
        component: CompanyFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Company'
        },
      },
      {
        path: 'companies/details/:id',
        component: CompanyDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Company Details'
        },
      },
      {
        path: 'countries',
        component: CountriesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Countries'
        },
      },
      {
        path: 'countries/add',
        component: CountryFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Country'
        },
      },
      {
        path: 'countries/edit/:id',
        component: CountryFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Country'
        },
      },
      {
        path: 'countries/details/:id',
        component: CountryDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Country Details'
        },
      },
      {
        path: 'favorites',
        component: FavoritesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Favorites'
        },
      },
      {
        path: 'favorites/add',
        component: FavoriteFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Favorite'
        },
      },
      {
        path: 'favorites/edit/:id',
        component: FavoriteFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Favorite'
        },
      },
      {
        path: 'favorites/details/:id',
        component: FavoriteDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Favorite Details'
        },
      },
      {
        path: 'fitness-classes',
        component: FitnessClassesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Classes'
        },
      },
      {
        path: 'fitness-classes/add',
        component: FitnessClassFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Fitness Class'
        },
      },
      {
        path: 'fitness-classes/edit/:id',
        component: FitnessClassFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Fitness Class'
        },
      },
      {
        path: 'fitness-classes/details/:id',
        component: FitnessClassDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Class Details'
        },
      },
      {
        path: 'fitness-goals',
        component: FitnessGoalsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Goals'
        },
      },
      {
        path: 'fitness-goals/add',
        component: FitnessGoalFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Fitness Goal'
        },
      },
      {
        path: 'fitness-goals/edit/:id',
        component: FitnessGoalFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Fitness Goal'
        },
      },
      {
        path: 'fitness-goals/details/:id',
        component: FitnessGoalDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Goal Details'
        },
      },
      {
        path: 'fitness-reservations',
        component: FitnessReservationsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Reservations'
        },
      },
      {
        path: 'fitness-reservations/add',
        component: FitnessReservationFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Fitness Reservation'
        },
      },
      {
        path: 'fitness-reservations/edit/:id',
        component: FitnessReservationFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Fitness Reservation'
        },
      },
      {
        path: 'fitness-reservations/details/:id',
        component: FitnessReservationDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Reservation Details'
        },
      },
      {
        path: 'fitness-sessions',
        component: FitnessSessionsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Sessions'
        },
      },
      {
        path: 'fitness-sessions/add',
        component: FitnessSessionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Fitness Session'
        },
      },
      {
        path: 'fitness-sessions/edit/:id',
        component: FitnessSessionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Fitness Session'
        },
      },
      {
        path: 'fitness-sessions/details/:id',
        component: FitnessSessionDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Fitness Session Details'
        },
      },
      {
        path: 'impressions',
        component: ImpressionsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Impressions'
        },
      },
      {
        path: 'impressions/add',
        component: ImpressionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Impression'
        },
      },
      {
        path: 'impressions/edit/:id',
        component: ImpressionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Impression'
        },
      },
      {
        path: 'impressions/details/:id',
        component: ImpressionDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Impression Details'
        },
      },
      {
        path: 'intensities',
        component: IntensitiesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Intensities'
        },
      },
      {
        path: 'intensities/add',
        component: IntensityFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Intensity'
        },
      },
      {
        path: 'intensities/edit/:id',
        component: IntensityFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Intensity'
        },
      },
      {
        path: 'intensities/details/:id',
        component: IntensityDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Intensity Details'
        },
      },
      {
        path: 'languages',
        component: LanguagesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Languages'
        },
      },
      {
        path: 'languages/add',
        component: LanguageFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Language'
        },
      },
      {
        path: 'languages/edit/:id',
        component: LanguageFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Language'
        },
      },
      {
        path: 'languages/details/:id',
        component: LanguageDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Language Details'
        },
      },
      {
        path: 'likes',
        component: LikesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Likes'
        },
      },
      {
        path: 'likes/add',
        component: LikeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Like'
        },
      },
      {
        path: 'likes/edit/:id',
        component: LikeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Like'
        },
      },
      {
        path: 'likes/details/:id',
        component: LikeDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Like Details'
        },
      },
      {
        path: 'live-channels',
        component: LiveChannelsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Live Channels'
        },
      },
      {
        path: 'live-channels/add',
        component: LiveChannelFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Live Channel'
        },
      },
      {
        path: 'live-channels/edit/:id',
        component: LiveChannelFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Live Channel'
        },
      },
      {
        path: 'live-channels/details/:id',
        component: LiveChannelDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Live Channel Details'
        },
      },
      {
        path: 'logs',
        component: LogsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Logs'
        },
      },
      {
        path: 'logs/add',
        component: LogFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Log'
        },
      },
      {
        path: 'logs/edit/:id',
        component: LogFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Log'
        },
      },
      {
        path: 'logs/details/:id',
        component: LogDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Log Details'
        },
      },
      {
        path: 'members',
        component: MembersComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Members'
        },
      },
      {
        path: 'members/add',
        component: MemberFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Member'
        },
      },
      {
        path: 'members/edit/:id',
        component: MemberFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Member'
        },
      },
      {
        path: 'members/details/:id',
        component: MemberDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Member Details'
        },
      },
      {
        path: 'sports',
        component: SportsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Sports'
        },
      },
      {
        path: 'sports/add',
        component: SportFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Sport'
        },
      },
      {
        path: 'sports/edit/:id',
        component: SportFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Sport'
        },
      },
      {
        path: 'sports/details/:id',
        component: SportDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Sport Details'
        },
      },
      {
        path: 'packs',
        component: PacksComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Packs'
        },
      },
      {
        path: 'packs/add',
        component: PackFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Pack'
        },
      },
      {
        path: 'packs/edit/:id',
        component: PackFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Pack'
        },
      },
      {
        path: 'packs/details/:id',
        component: PackDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Pack Details'
        },
      },
      {
        path: 'package-types',
        component: PackageTypesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Package Types'
        },
      },
      {
        path: 'package-types/add',
        component: PackageTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Package Type'
        },
      },
      {
        path: 'package-types/edit/:id',
        component: PackageTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Package Type'
        },
      },
      {
        path: 'package-types/details/:id',
        component: PackageTypeDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Package Type Details'
        },
      },
      {
        path: 'posts',
        component: PostsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Posts'
        },
      },
      {
        path: 'posts/add',
        component: PostFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Post'
        },
      },
      {
        path: 'posts/edit/:id',
        component: PostFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Post'
        },
      },
      {
        path: 'posts/details/:id',
        component: PostDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Post Details'
        },
      },
      {
        path: 'post-types',
        component: PostTypesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Post Types'
        },
      },
      {
        path: 'post-types/add',
        component: PostTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Post Type'
        },
      },
      {
        path: 'post-types/edit/:id',
        component: PostTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Post Type'
        },
      },
      {
        path: 'post-types/details/:id',
        component: PostTypeDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Post Type Details'
        },
      },
      {
        path: 'prices',
        component: PricesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Prices'
        },
      },
      {
        path: 'prices/add',
        component: PriceFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Price'
        },
      },
      {
        path: 'prices/edit/:id',
        component: PriceFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Price'
        },
      },
      {
        path: 'prices/details/:id',
        component: PriceDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Price Details'
        },
      },
      {
        path: 'ratings',
        component: RatingsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Ratings'
        },
      },
      {
        path: 'ratings/add',
        component: RatingFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Rating'
        },
      },
      {
        path: 'ratings/edit/:id',
        component: RatingFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Rating'
        },
      },
      {
        path: 'ratings/details/:id',
        component: RatingDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Rating Details'
        },
      },
      {
        path: 'reviews',
        component: ReviewsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Reviews'
        },
      },
      {
        path: 'reviews/add',
        component: ReviewFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Review'
        },
      },
      {
        path: 'reviews/edit/:id',
        component: ReviewFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Review'
        },
      },
      {
        path: 'reviews/details/:id',
        component: ReviewDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Review Details'
        },
      },
      {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Settings'
        },
      },
      {
        path: 'settings/add',
        component: SettingFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Setting'
        },
      },
      {
        path: 'settings/edit/:id',
        component: SettingFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Setting'
        },
      },
      {
        path: 'settings/details/:id',
        component: SettingDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Setting Details'
        },
      },
      {
        path: 'sharings',
        component: SharingsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Sharings'
        },
      },
      {
        path: 'sharings/add',
        component: SharingFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Sharing'
        },
      },
      {
        path: 'sharings/edit/:id',
        component: SharingFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Sharing'
        },
      },
      {
        path: 'sharings/details/:id',
        component: SharingDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Sharing Details'
        },
      },
      {
        path: 'shows',
        component: ShowsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Shows'
        },
      },
      {
        path: 'shows/add',
        component: ShowFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Show'
        },
      },
      {
        path: 'shows/edit/:id',
        component: ShowFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Show'
        },
      },
      {
        path: 'shows/details/:id',
        component: ShowDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Show Details'
        },
      },
      {
        path: 'subscriptions',
        component: SubscriptionsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Subscriptions'
        },
      },
      {
        path: 'subscriptions/add',
        component: SubscriptionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Subscription'
        },
      },
      {
        path: 'subscriptions/edit/:id',
        component: SubscriptionFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Subscription'
        },
      },
      {
        path: 'subscriptions/details/:id',
        component: SubscriptionDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Subscription Details'
        },
      },
      {
        path: 'users',
        component: UsersComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Users'
        },
      },
      {
        path: 'users/add',
        component: UserFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New User'
        },
      },
      {
        path: 'users/edit/:id',
        component: UserFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit User'
        },
      },
      {
        path: 'users/details/:id',
        component: UserDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'User Details'
        },
      },
      {
        path: 'videos',
        component: VideosComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Videos'
        },
      },
      {
        path: 'videos/add',
        component: VideoFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Video'
        },
      },
      {
        path: 'videos/edit/:id',
        component: VideoFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Video'
        },
      },
      {
        path: 'videos/details/:id',
        component: VideoDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Video Details'
        },
      },
      {
        path: 'videos/converter/:id',
        component: VideoConverterComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Video Converter'
        },
      },
      {
        path: 'video-categories',
        component: VideoCategoriesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Video Categories'
        },
      },
      {
        path: 'video-categories/add',
        component: VideoCategoryFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Video Category'
        },
      },
      {
        path: 'video-categories/edit/:id',
        component: VideoCategoryFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Video Category'
        },
      },
      {
        path: 'video-categories/details/:id',
        component: VideoCategoryDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Video Category Details'
        },
      },
      {
        path: 'video-types',
        component: VideoTypesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Video Types'
        },
      },
      {
        path: 'video-types/add',
        component: VideoTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Video Type'
        },
      },
      {
        path: 'video-types/edit/:id',
        component: VideoTypeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Video Type'
        },
      },
      {
        path: 'video-types/details/:id',
        component: VideoTypeDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Video Type Details'
        },
      },
      {
        path: 'visits',
        component: VisitsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Visits'
        },
      },
      {
        path: 'visits/add',
        component: VisitFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Visit'
        },
      },
      {
        path: 'visits/edit/:id',
        component: VisitFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Visit'
        },
      },
      {
        path: 'visits/details/:id',
        component: VisitDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Visit Details'
        },
      },

      {
        path: 'challenges',
        component: ChallengesComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'challenges'
        },
      },
      {
        path: 'challenges/add',
        component: ChallengeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'New Challenge'
        },
      },
      {
        path: 'challenges/edit/:id',
        component: ChallengeFormComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Edit Challenge'
        },
      },
      {
        path: 'challenges/details/:id',
        component: ChallengeDetailsComponent,
        canActivate: [AuthGuard],
        data: {
          title: 'Challenge Details'
        },
      },
    ]
  },
  { path: '**', component: DefaultLayoutComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class EfitRoutingModule { }

